import short from 'short-uuid';

export const shortID = (uuid?: string) => {
  if (!uuid || uuid === 'new') return null;
  const translator = short(short.constants.flickrBase58);
  return translator.fromUUID(uuid);
};

export const uuid = (id?: string | null | undefined) => {
  if (!id) return null;
  if (id.length === 36) return id;
  try {
    const translator = short(short.constants.flickrBase58);
    return translator.toUUID(id);
  } catch (e) {
    return id;
  }
};
